module.exports = __webpack_public_path__ + "static/indian-0d65c49f2dec8c67389f82aa7596638c.jpg";